import { useEffect, useState } from "react";
import api from "@/lib/api";

// Runtime monetization flags from the backend. Defaults are OFF so no paid UI
// ever flashes; flip PAYMENTS_ENABLED / PROMO_ENABLED in backend/.env to re-enable.
let _cache = null;
let _promise = null;

export function useConfig() {
  const [cfg, setCfg] = useState(_cache || { paymentsEnabled: false, promoEnabled: false });
  useEffect(() => {
    if (_cache) { setCfg(_cache); return; }
    if (!_promise) {
      _promise = api.get("/config").then((r) => {
        _cache = { paymentsEnabled: !!r.data.payments_enabled, promoEnabled: !!r.data.promo_enabled };
        return _cache;
      }).catch(() => ({ paymentsEnabled: false, promoEnabled: false }));
    }
    _promise.then(setCfg);
  }, []);
  return cfg;
}
